export default __webpack_public_path__ + "b8c24d3838b7fd5f47da89f58b1ca75c.png";